import StyledWrap from './StyledWrap'
export default StyledWrap
